
import { Options, Vue } from "vue-class-component";
import { StudentRecord } from "../interfaces/student";

import moment from "moment";

@Options({
  computed: {
    onTimeStudents() {
      const students = this.students as Map<string, StudentRecord>;
      return Array.from(students.values()).filter(
        (student: StudentRecord) => student.checkinTime < this.lateTime
      );
    },

    lateStudents() {
      const students = this.students as Map<string, StudentRecord>;
      return Array.from(students.values()).filter(
        (student: StudentRecord) => student.checkinTime >= this.lateTime
      );
    },

    absentStudents() {
      const students = this.students as Map<string, StudentRecord>;
      return Array.from(students.values()).filter(
        (student: StudentRecord) => student.checkinTime === undefined
      );
    },
  },

  methods: {
    moment: function (checkinTime: number): string {
      if (checkinTime) {
        return moment(checkinTime).format("HH:mm");
      }
      return "";
    },
  },

  props: {
    students: new Map<string, StudentRecord>(),
    lateTime: Number,
  },
})
export default class Today extends Vue {}
